import {errorMessage, errorMessageList, successMessage} from "@/helpers/common";
import axios from "@/plugins/axios";
import { canEdit, canDelete } from "@/helpers/Permissions";

export function extractErrorMessage(context, error) {
  const response = error?.response;
  const errors = response?.data?.errors;
  const errorList = errors?.error;

  if (Array.isArray(errorList) && errorList.length > 0) {
    return errorList[0];
  }

  if (typeof errorList === "string") {
    return errorList;
  }

  if (typeof response?.data?.message === "string") {
    return response.data.message;
  }

  return context.$t("error_alert_text");
}

export function getData(context, createCallback = undefined, updateCallback = undefined) {

  if(context.$route.params.uuid && context.$route.params.uuid !== 'add') {
    context.config.get({
      uuid: context.$route.params.uuid
    }).then((response) => {
      if(response === null || ( response && !response.is_active && response.deleted_at )) {
        errorMessage(context, context.$t('common.not_available', { name: context.name }));
        setTimeout(function(){
          context.$router.push({
            path: context.config.list_url,
          });
        }, 1000);
      } else {
        context.data = response;

        //after data is loaded
        if(updateCallback instanceof Function) {
          updateCallback(context.data);
        }
      }

    }).catch((e) => {
      console.log('load data ex', e);
      errorMessage(context, context.$t('common.not_found', { name: context.name }));
      setTimeout(function(){
        context.$router.push({
          path: context.config.list_url,
        });
      }, 1000);
    });
  } else {
    //init, while creating new
    if(createCallback instanceof Function) {
      createCallback({});
    }
  }
}

export function deleteAction(context) {
  if(!canDelete(context)) return;

  return new Promise((resolve, reject) => {
    context.config.delete({
      uuid: context.data.uuid,
    }).then((response) => {
      successMessage(context, response.message);
      resolve(response);
    }).catch( function(error) {
      errorMessage(context, error.response.data.message);
      reject(error);
    })
  });
}

export function confirmDelete(context, title = null, callback = null) {
  context.$dialog.confirm(title ?? context.$t('common.confirm_delete', { title: context.data.name }))
    .then((dialog) => {
      if (callback instanceof Function) {
        callback();
        dialog.close();
      } else {
        deleteAction(context).then((resp) => {
          dialog.close();

          if (context.config.list_url) {
            setTimeout(function(){
              context.$router.push({
                path: context.config.list_url,
              });
            }, 500);
          }

        }).catch((e) => {
          dialog.close();
        });
      }
    });
}

export function save(context, backPath = undefined, data_to_save = undefined) {
  if(!canEdit(context)) return;

  return new Promise((resolve, reject) => {
    context.$v.data.$touch();
    if(!context.$v.data.$invalid) {
      context.$v.data.$reset();

      const data = data_to_save ?? context.data;
      if(data.uuid) {
        context.config.update(data).then((response) => {
          successMessage(context, response.message);

          if(backPath) {
            setTimeout(function() {
              context.$router.push({
                path: backPath
              }).catch((e) => {
                window.location.href = backPath
              });
            }, 300);
          }

          resolve(response.data);
        }).catch((e) => {
          if (e.response?.status === 400 || e.response?.status === 403) {
            errorMessage(context, extractErrorMessage(context, e));
          } else {
            errorMessageList(context, e.errors);
          }
          reject();
        });
      } else {
        if(backPath) {
            context.backPath = backPath;
        }

        context.config.create(data).then((response) => {
          successMessage(context, response.message);
          setTimeout(function() {
            if(context.backPath) {
              context.$router.push({
                path: context.backPath,
              }).catch((e) => {
                  window.location.href = context.backPath
              });
            } else {
              /*context.$router.push({
                path: context.config.list_url+'/'+response.data.uuid,
              }).catch((e) => {
                window.location.href = context.config.list_url+'/'+response.data.uuid;
              });*/ // ??
            }
          }, 500);
          resolve(response.data);
        }).catch((e) => {
          if (context.saveButtonPressed) {
            context.saveButtonPressed = false;
          }
          if (e.response?.status === 400 || e.response?.status === 403) {
            errorMessage(context, extractErrorMessage(context, e));
          } else {
            errorMessageList(context, e.errors);
          }
          reject();
        });
      }
    } else {
      errorMessage(context, context.$t('fill_out_error'));
      reject();
    }
  });
}

export function saveAndNew(context, backPath = undefined, default_data = null, data_to_save = undefined) {
    return save(context, backPath, data_to_save).then((resp) => {
      if(backPath) {
        context.$router.push(
          backPath
        ).then((navi) => {
          context.data = default_data ?? {};
        }).catch((e) => {
          window.location.href = backPath;
        })
      } else {
        return resp;
      }
    });
}

export function newObject(context) {
  context.data = {};
  let addUrl = 'add';

  context.$router.push({
    path: addUrl
  }).catch((e)=>{
    window.location.href = addUrl;
  });
}

export function gotoList(context) {
  context.$router.push({
    path: context.config.list_url,
  })
}

export function goto(context, path, name) {
  context.$router.push({
    path: path,
    query: {
      backPath: context.$route.fullPath,
      name: name
    }
  })
}

export function handleParams(context) {
  let route = context.$route;

  if(route.query.backPath) {
    context.backPath = route.query.backPath;
  }

  if(route.query.name) {
    context.data.name = route.query.name;
  }
}

export default {
  getData, deleteAction, confirmDelete, save, newObject, gotoList, handleParams, bulkAction
}

export function handleError(context, e) {
  console.log('error: ', e.response);
  if (e.response && (e.response.status === 400 || e.response.status === 500)) {
    errorMessage(context, extractErrorMessage(context, e));
  }
}

export function bulkAction(context, options = {}) {
  const {
    endpoint,
    action,
    uuids,
    data,
    confirmMessage,
    successMessageBuilder,
    emptyMessage,
    axiosConfig,
  } = options;

  if (!endpoint || !action) {
    errorMessage(context, context.$t("error_alert_text"));
    return Promise.reject(new Error("Missing endpoint or action"));
  }

  if (!Array.isArray(uuids) || uuids.length === 0) {
    errorMessage(context, emptyMessage || context.$t("common.no_data_text"));
    return Promise.reject(new Error("No uuids provided"));
  }

  const payload = {
    action,
    uuids,
    data: data ?? {},
  };

  const doRequest = () =>
    axios
      .post(endpoint, payload, axiosConfig)
      .then((resp) => {
        const response = resp?.data ?? resp;
        const defaultMessage = `${action}: ${response?.updated ?? 0} updated, ${response?.deleted ?? 0} deleted (total ${response?.total ?? 0})`;
        const message = successMessageBuilder instanceof Function ? successMessageBuilder(response) : response?.message || defaultMessage;
        successMessage(context, message);
        return response;
      })
      .catch((e) => {
        handleError(context, e);
        throw e;
      });

  if (confirmMessage) {
    return context.$dialog.confirm(confirmMessage).then((dialog) => {
      return doRequest().finally(() => {
        if (dialog && typeof dialog.close === "function") {
          dialog.close();
        }
      });
    });
  }

  return doRequest();
}

export function readFile(fileChangeEvent) {
  let uploadedFile = null;

  if (fileChangeEvent.value.length > 0) {
    const file = fileChangeEvent.value[0];

    uploadedFile = {
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified,
      base64: null,
    };

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      uploadedFile.base64 = reader.result;
    };
  } else {
    uploadedFile = null;
  }

  return uploadedFile;
}
